import RequiredNumberInput from "components/ValidatedFields/RequiredNumberInput";
import React from "react";

interface Props {
  value: number
  onChange: (value: number) => void
  onEnter: (value: number) => void;
  onEsc: () => void;
  type: "due" | "send";

  maxValue: number;
}

export const DaysAfterDateInput = (props: Props) => {
  return <div className="flex gap">
    <div>
      <RequiredNumberInput
        onEnterPressed={props.onEnter}
        onEscPressed={props.onEsc}
        validatorKey="daysAfterDate"
        value={props.value}
        onChange={props.onChange}
        width={60}
        decimalPoints={0}
        canBeEmpty
        minValue={1}
        maxValue={props.maxValue}
        maxLength={3}
        canBeNegative={false}
        autoFocus
      />
    </div>
    <div>{RESX.DateTime.days} {props.type === "due" ? RESX.DateTime.afterDueDate : RESX.DateTime.afterSendDate}</div>
  </div>;
};

export const DaysAfterDateText = ({ days, type }: { days: number, type: "due" | "send" }) => {
  return <div>{days === 1 ? RESX.DateTime.YDay : `${days} ${RESX.DateTime.days}`} {type === "due" ? RESX.DateTime.afterDueDate : RESX.DateTime.afterSendDate}</div>;
}